var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("EntityLandingHeader", {
        attrs: {
          "background-image-url": _vm.backgroundImageUrl,
          entity: _vm.performer
        }
      }),
      _vm._v(" "),
      _vm.showFilters
        ? _c("section", [
            _vm.isPerformerInLeagueSports
              ? _c("div", { staticClass: "sports-performer-filters" }, [
                  _c(
                    "div",
                    {
                      staticClass: "whereabouts-filter",
                      class: {
                        "whereabouts-filter--multiline":
                          _vm.isMultipleLineFilters
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "whereabouts-filter__shop-by" },
                        [_vm._v("Shop")]
                      ),
                      _vm._v(" "),
                      _c("Tabs", {
                        attrs: {
                          "default-item": _vm.whereaboutsItems[0],
                          "dropdown-query-param": "whereabouts",
                          items: _vm.whereaboutsItems
                        },
                        on: {
                          "reset-tabs-dropdown": function($event) {
                            _vm.$router.push(_vm.makeWhereaboutsRoute("all"))
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "sports-performer-filters--mobile" },
                    [
                      _c(
                        "div",
                        { staticClass: "date-filter" },
                        [
                          _c("span", { staticClass: "icon-calendar-blank" }),
                          _vm._v(" "),
                          _c(
                            "fx-date-range",
                            {
                              attrs: {
                                align: "left",
                                "data-e2e": "search.date-filter",
                                "min-date": "today",
                                "custom-option-copy": "Choose Date",
                                "default-option-copy": "Dates",
                                presets: _vm.dateRangeFilterPresets
                              },
                              on: { input: _vm.onDateRangeInput },
                              model: {
                                value: _vm.dateRange,
                                callback: function($$v) {
                                  _vm.dateRange = $$v
                                },
                                expression: "dateRange"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "icon-chevron-lg-down",
                                attrs: { slot: "caret" },
                                slot: "caret"
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isShowOpponentsFilters
                        ? _c(
                            "div",
                            { staticClass: "opponent-filter" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "opponent-filter__vs fx-hidden--small fx-hidden--medium"
                                },
                                [_vm._v("vs.")]
                              ),
                              _vm._v(" "),
                              _c(
                                "fx-select",
                                {
                                  attrs: {
                                    "default-option": {
                                      label: "Opponent",
                                      value: null
                                    },
                                    "disable-native": true,
                                    options: _vm.opponents
                                  },
                                  on: { input: _vm.onOpponentIdSelect },
                                  model: {
                                    value: _vm.opponentId,
                                    callback: function($$v) {
                                      _vm.opponentId = $$v
                                    },
                                    expression: "opponentId"
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "icon-chevron-lg-down",
                                    attrs: { slot: "caret" },
                                    slot: "caret"
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ])
              : !_vm.isPerformerInLeagueSports
              ? _c("div", { staticClass: "non-league-performer-filters" }, [
                  _c(
                    "div",
                    { staticClass: "non-sports-locations-filter" },
                    [
                      _c("span", { staticClass: "icon-location-marker" }),
                      _vm._v(" "),
                      _c(
                        "fx-select",
                        {
                          attrs: {
                            "default-option": {
                              label: "Any Location",
                              value: null
                            },
                            "disable-native": true,
                            options: _vm.locations
                          },
                          on: { input: _vm.onLocationIdSelect },
                          model: {
                            value: _vm.locationId,
                            callback: function($$v) {
                              _vm.locationId = $$v
                            },
                            expression: "locationId"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "icon-chevron-lg-down",
                            attrs: { slot: "caret" },
                            slot: "caret"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "date-filter date-filter--non-sports-performer"
                    },
                    [
                      _c("span", { staticClass: "icon-calendar-blank" }),
                      _vm._v(" "),
                      _c(
                        "fx-date-range",
                        {
                          attrs: {
                            align: "left",
                            "data-e2e": "search.date-filter",
                            "min-date": "today",
                            "custom-option-copy": "Choose Date",
                            "default-option-copy": "Dates",
                            presets: _vm.dateRangeFilterPresets
                          },
                          on: { input: _vm.onDateRangeInput },
                          model: {
                            value: _vm.dateRange,
                            callback: function($$v) {
                              _vm.dateRange = $$v
                            },
                            expression: "dateRange"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "icon-chevron-lg-down",
                            attrs: { slot: "caret" },
                            slot: "caret"
                          })
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isPerformerInLeagueSports && _vm.whereaboutsItems[0].isActive
        ? _c("section", { staticClass: "local-events-section" }, [
            _c("div", { staticClass: "background" }, [
              _c("div", { staticClass: "local-performer-filter-container" }, [
                _c("h2", { staticClass: "local-performer-filter-header" }, [
                  _vm._v("Near")
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "local-performer-filter" },
                  [
                    _c("LocationFilter", {
                      attrs: {
                        "default-location": _vm.$config.defaultLocation
                          ? _vm.$config.defaultLocation
                          : _vm.userLocation,
                        location: _vm.location,
                        locationFilterCopy: ""
                      },
                      on: {
                        error: _vm.onLocationError,
                        select: _vm.onLocalEventLocationSelect
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "EventList",
                    {
                      attrs: {
                        events: _vm.localEvents,
                        "format-points": _vm.formatPoints,
                        "is-loading-events": _vm.isLoadingLocalEvents,
                        "is-loading-more-events": _vm.isLoadingMoreLocalEvents,
                        "is-loyalty-pricing":
                          _vm.$store.state.isRedeemingLoyaltyPoints,
                        "is-show-thumbnails": _vm.isShowThumbnails,
                        "load-more-copy": "Show More",
                        "loading-more-copy": "Loading More Events...",
                        "make-event-route": _vm.makeEventRoute,
                        "on-event-click": _vm.onEventClick,
                        pagination: _vm.localEventsPagination
                      },
                      on: { "load-more-events": _vm.onLoadMoreLocalEvents }
                    },
                    [
                      _c(
                        "template",
                        { slot: "events-not-found" },
                        [
                          _c(
                            "transition",
                            { attrs: { mode: "out-in", name: "fade" } },
                            [
                              _c("NoResults", {
                                attrs: {
                                  "show-redirect": Boolean(
                                    !_vm.locationId &&
                                      !_vm.dateRange &&
                                      !_vm.opponentId &&
                                      _vm.isAllEvents
                                  ),
                                  "no-results-copy": "There Are No Games Nearby"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isPerformerInLeagueSports
        ? _c(
            "h2",
            {
              staticClass: "scheduled-event-list-header",
              class: {
                "scheduled-event-list-header--nearby-events":
                  _vm.isPerformerInLeagueSports &&
                  _vm.whereaboutsItems[0].isActive
              }
            },
            [_vm._v("\n        Schedule\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        [
          _c(
            "EventList",
            {
              attrs: {
                events: _vm.events,
                "format-points": _vm.formatPoints,
                "is-loading-events": _vm.isLoadingEvents,
                "is-loading-more-events": _vm.isLoadingMoreEvents,
                "is-loyalty-pricing": _vm.$store.state.isRedeemingLoyaltyPoints,
                "is-show-thumbnails": _vm.isShowThumbnails,
                "load-more-copy": "Show More",
                "loading-more-copy": "Loading More Events...",
                "make-event-route": _vm.makeEventRoute,
                "on-event-click": _vm.onEventClick,
                pagination: _vm.pagination
              },
              on: { "load-more-events": _vm.onLoadMoreEvents }
            },
            [
              _c(
                "template",
                { slot: "events-not-found" },
                [
                  _c(
                    "transition",
                    { attrs: { mode: "out-in", name: "fade" } },
                    [
                      _c("NoResults", {
                        attrs: {
                          "show-redirect": Boolean(
                            !_vm.locationId &&
                              !_vm.dateRange &&
                              !_vm.opponentId &&
                              _vm.isAllEvents
                          ),
                          "no-results-copy": _vm.noEventsFoundCopy
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }